import { createFileRoute } from '@tanstack/react-router'

import { HealthInsuranceSanteclairPage } from '../../../../../components/pages/health-insurance/santeclair-page.tsx'
import { PermissionChecker } from '../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/health-insurance/santeclair')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <HealthInsuranceSanteclairPage />
    </PermissionChecker>
  ),
})
